import React, { useEffect, useState } from 'react';
import { useParams, useHistory, useNavigate } from 'react-router-dom';
import { db,storage } from '../FireBase'; // Import Firestore
import { collection, query, where, getDocs, doc, getDoc, addDoc,updateDoc} from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL} from "firebase/storage";
import { Container, Table, Alert, Button, Modal, Form,Row,Col,Card ,Tab,Tabs} from 'react-bootstrap';
import { faEdit, faFaceAngry, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ToastAlert from '../components/ToastAlert';
import { Link } from 'react-router-dom';
import '../css/font.css';
import Loading from '../components/Loading';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FaBoxesPacking, FaNoteSticky, FaPrint } from 'react-icons/fa6';
import axios from 'axios';



const ProcessScheme = () => {
    const { id } = useParams(); // Get the scheme ID from the URL
    const [scheme, setScheme] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');
    const navigate = useNavigate(); // Initialize useNavigate
    const [paidcustomers, setPaidCustomers] = useState([]); 
    const [customers, setCustomers] = useState([]); 
    const [Unpaidcustomers, setUnpaidCustomers] = useState([]); 
    const [products, setProducts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [scannedBarcodes, setScannedBarcodes] = useState({});
    const [barcodeError, setBarcodeError] = useState('');
    const [packedOrders, setPackedOrders] = useState([]);
    const [billedOrders, setBilledOrders] = useState([]);
    const [processedOrders,setProcessedOrders] = useState([]);
    
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderNotes, setOrderNotes] = useState('');
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [billingUsers, setBillingUsers] = useState([]);
    const [logisticsUsers, setLogisticsUsers] = useState([]);
    const [selectedBillingUser, setSelectedBillingUser] = useState([]);
    const [selectedLogisticsUser, setSelectedLogisticsUser] = useState([]);
    const [selectedCompletedUsers, setSelectedCompletedUsers] = useState([]);
    const [activeTab, setActiveTab] = useState('paidcustomers');
    const [activeTab2, setActiveTab2] = useState('notpacked');
    const [currentUser, setCurrentUser] = useState(null);
    const [trackingLink, setTrackingLink] = useState('');
    const [uploadedSlip, setUploadedSlip] = useState(null);
    const [uploadedSlipURL, setUploadedSlipURL] = useState('');
    

    const[packedCustomers,setPackedCustomers]=useState('');
    const[notPackedCustomers,setNotPackedCustomers]=useState('');
   

  
    useEffect(() => {
        fetchCurrentUser();
        fetchData();
    }, [id]);

    const fetchData = async () => {
     
        await fetchCustomers();
        await fetchSchemeDetails();
        await fetchBilledOrders();
        await fetchProcessedOrders();
        await fetchBillingUsers();
        await fetchLogisticsUsers();
        await fetchPackedCustomers();
        await fetchNotPackedCustomers();
        await fetchPackedOrders();
    };
    const syncData =async()=>{
        setToastMessage("Synchronization!!!");
        setToastVariant('warning');
        setShowToast(true);
        await fetchData();
        setToastMessage("Synchronization Complete!!!");
        setToastVariant('success');
        setShowToast(true);
        
    }

    const fetchBillingUsers = async () => {
        try {
            const billingQuery = query(collection(db, 'crm_users'), where('role', '==', 'Billing'));
            const billingSnapshot = await getDocs(billingQuery);
            const billingData = billingSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setBillingUsers(billingData);
        } catch (error) {
            console.error('Error fetching billing users:', error);
        }
    };

    const fetchLogisticsUsers = async () => {
        try {
            const logisticsQuery = query(collection(db, 'crm_users'), where('role', '==', 'Logistics'));
            const logisticsSnapshot = await getDocs(logisticsQuery);
            const logisticsData = logisticsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setLogisticsUsers(logisticsData);
        } catch (error) {
            console.error('Error fetching logistics users:', error);
        }
    };
    const fetchCurrentUser = async () => {
        try {
            const storedUser = JSON.parse(sessionStorage.getItem('user')); // Assuming the user object is stored as a JSON string
            if (storedUser && storedUser.uid) {
                const userRef = doc(db, 'crm_users', storedUser.uid);
                const userDoc = await getDoc(userRef);
                if (userDoc.exists()) {
                    setCurrentUser({ id: userDoc.id, ...userDoc.data() });
                } else {
                    console.log('No such user document!');
                }
            }
        } catch (error) {
            console.error('Error fetching current user:', error);
        }
    };

  

    const fetchSchemeDetails = async () => {
        try {
            const schemeRef = doc(db, 'schemes', id);
            const schemeDoc = await getDoc(schemeRef);
            if (schemeDoc.exists()) {
                const schemeData = { id: schemeDoc.id, ...schemeDoc.data() };
                setScheme(schemeData);
            }else {
                console.log('No such document!');
            }
        } catch (error) {
            console.error('Error fetching scheme details:', error);
            
        }
    };

    const fetchCustomers = async () => {
        try {
            const subscriptionsQuery = query(collection(db, 'subscriptions'), where('schemeId', '==', id));
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
            const userIds = subscriptionsSnapshot.docs.map(doc => doc.data().userId);

            const customerPromises = userIds.map(async userId => {
                const userRef = query(collection(db, 'users'), where('cusmid', '==', userId));
                const userSnapshot = await getDocs(userRef);
                if (!userSnapshot.empty) {
                    const userDoc = userSnapshot.docs[0];
                    return { id: userDoc.id, ...userDoc.data() };
                } else {
                    console.log(`No such user document for userId: ${userId}`);
                    return null;
                }
            });

            const customersData = await Promise.all(customerPromises);
            setCustomers(customersData.filter(customer => customer !== null));
        } catch (error) {
            console.error('Error fetching customers:', error);
          
        }
    };

    const fetchPackedCustomers = async () => {
        try {
            const storedUser = JSON.parse(sessionStorage.getItem('user'));
    
            // Query subscriptions where schemeId matches, PackingStatus is 'Packed', and logisticsUserId matches
            const subscriptionsQuery = query(
                collection(db, 'subscriptions'),
                where('schemeId', '==', id),
                where('PackingStatus', '==', 'Packed'),
                where('logisticsUserId', '==', storedUser.uid)
            );
    
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
            const userIds = subscriptionsSnapshot.docs
                .filter(doc => parseInt(doc.data().totalMonths) === parseInt(doc.data().paidMonths))
                .map(doc => doc.data().userId);
    
            // Fetch customer and order-processing details
            const customerPromises = userIds.map(async (userId) => {
                // Fetch user details from users collection
                const userRef = query(collection(db, 'users'), where('cusmid', '==', userId));
                const userSnapshot = await getDocs(userRef);
                if (userSnapshot.empty) {
                    console.log(`No user document found for userId: ${userId}`);
                    return null;
                }
    
                const userDoc = userSnapshot.docs[0];
                const userData = userDoc.data();
    
                // Fetch order-processing documents for the same schemeId and userId
                const orderQuery = query(
                    collection(db, 'order-processing'),
                    where('schemeId', '==', id),
                    where('customerId', '==', userId)
                );
    
                const orderSnapshot = await getDocs(orderQuery);
                const ordersProcess = orderSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    
                // Find the matching subscription document
                const subscriptionDoc = subscriptionsSnapshot.docs.find(doc => doc.data().userId === userId);
    
                return {
                    id: userDoc.id,
                    ...userData,
                    billingUserId: subscriptionDoc?.data().billingUserId || null,
                    logisticsUserId: subscriptionDoc?.data().logisticsUserId || null,
                    schemeId: subscriptionDoc?.data().schemeId || null,
                    ordersProcess, // Include related orders
                };
            });
    
            const customersData = await Promise.all(customerPromises);
            setPackedCustomers(customersData.filter(customer => customer !== null));
        } catch (error) {
            console.error('Error fetching customers and orders:', error);
        }
    };
    

    const fetchNotPackedCustomers = async () => {
        try {
            const storedUser = JSON.parse(sessionStorage.getItem('user'));
            console.log(storedUser)
            const subscriptionsQuery = query(collection(db, 'subscriptions'), where('schemeId', '==', id), where('PackingStatus','==','Assigned-for-packing'),where('logisticsUserId','==', storedUser.uid));
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
            const userIds = subscriptionsSnapshot.docs
                .filter(doc => parseInt(doc.data().totalMonths) ===parseInt( doc.data().paidMonths))
                .map(doc => doc.data().userId);

            const customerPromises = userIds.map(async userId => {
                const userRef = query(collection(db, 'users'), where('cusmid', '==', userId));
                const userSnapshot = await getDocs(userRef);
                if (!userSnapshot.empty) {
                    const userDoc = userSnapshot.docs[0];
                    const subscriptionDoc = subscriptionsSnapshot.docs.find(doc => doc.data().userId === userId);
                    return { id: userDoc.id, ...userDoc.data(),  
                        billingUserId: subscriptionDoc.data().billingUserId,
                        logisticsUserId: subscriptionDoc.data().logisticsUserId,
                        schemeId:subscriptionDoc.data().schemeId,
                };
                } else {
                    console.log(`No such user document for userId: ${userId}`);
                    return null;
                }
            });

            const customersData = await Promise.all(customerPromises);
            setNotPackedCustomers(customersData.filter(customer => customer !== null));
            console.log(customersData)
        } catch (error) {
            console.error('Error fetching customers:', error);
           
        }
    };



    const fetchPackedOrders = async () => {
          try {
              const packedOrdersQuery = query(collection(db, 'order-processing'), where('status', '==', 'Packed'), where('schemeId', '==', id));
              const packedOrdersSnapshot = await getDocs(packedOrdersQuery);
              const packedOrdersData = packedOrdersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
              setPackedOrders(packedOrdersData);
          } catch (error) {
              console.error('Error fetching packed orders:', error);
            
          }
      };
    const fetchBilledOrders = async () => {
        try {
            const billedOrdersQuery = query(collection(db, 'order-processing'), where('BillingStatus', '==', 'Billed'), where('schemeId', '==', id));
            const billedOrdersSnapshot = await getDocs(billedOrdersQuery);
            const billedOrdersData = billedOrdersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setBilledOrders(billedOrdersData);
        } catch (error) {
            console.error('Error fetching packed orders:', error);
          
        }
    };
    const fetchProcessedOrders = async () => {
        try {
            const processedOrdersQuery = query(collection(db, 'order-processing'), where('PackingStatus', '==', 'Packed'), where('schemeId', '==', id));
            const processedOrdersSnapshot = await getDocs(processedOrdersQuery);
            const processedOrdersData = processedOrdersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setProcessedOrders(processedOrdersData);
        } catch (error) {
            console.error('Error fetching packed orders:', error);
          
        }
    };
    

    const handleShowNotesModal = (order) => {
        console.log(order.ordersProcess[0].BillingStatus);

        setSelectedOrder(order);
        setOrderNotes(order.ordersProcess[0].notes || '');
        setTrackingLink(order.ordersProcess[0].trackingLink || '');
        setShowNotesModal(true);
        setUploadedSlipURL(order.ordersProcess[0].slipURL || '');
    };

    const handleCloseNotesModal = () => {
        setShowNotesModal(false);
        setSelectedOrder(null);
        setOrderNotes('');
    };

    const handleNotesSubmit = async () => {
        try {
            console.log(selectedOrder);
            if (selectedOrder) {
                let slipURL = selectedOrder.slipURL || '';
    
                // Upload slip if a new file is selected
                if (uploadedSlip) {
                    const storageRef = ref(storage, `orderSlips/${selectedOrder.schemeId}_${uploadedSlip.cusmid}`);
                    await uploadBytes(storageRef, uploadedSlip);
                    slipURL = await getDownloadURL(storageRef);
                }
    
                // Query to find order-processing documents matching schemeId and customerId
                const orderQuery = query(
                    collection(db, 'order-processing'),
                    where('customerId', '==', selectedOrder.cusmid),
                    where('schemeId', '==', selectedOrder.schemeId)
                );
    
                // Query to find subscription documents matching schemeId and customerId
                const subscriptionQuery = query(
                    collection(db, 'subscriptions'),
                    where('userId', '==', selectedOrder.cusmid),
                    where('schemeId', '==', selectedOrder.schemeId)
                );
    
                // Fetch matching documents
                const orderSnapshot = await getDocs(orderQuery);
                const subscriptionSnapshot = await getDocs(subscriptionQuery);
                const updatePromises = [];
    
                // Update order-processing documents
                if (!orderSnapshot.empty) {
                    orderSnapshot.docs.forEach(docSnap => {
                        const orderRef = doc(db, 'order-processing', docSnap.id);
                        updatePromises.push(updateDoc(orderRef, {
                            notes: orderNotes,
                            trackingLink: trackingLink,
                            slipURL: slipURL,
                            packageProcessedBy: currentUser ? currentUser.username : 'Unknown',
                            deliveryStatus: "Processed"
                        }));
                    });
                } else {
                    console.warn("No matching orders found for this customer and scheme.");
                }
    
                // Update subscription documents
                if (!subscriptionSnapshot.empty) {
                    subscriptionSnapshot.docs.forEach(docSnap => {
                        const subscriptionRef = doc(db, 'subscriptions', docSnap.id);
                        updatePromises.push(updateDoc(subscriptionRef, {
                            packageProcessedBy: currentUser ? currentUser.username : 'Unknown',
                            deliveryStatus: "Processed"
                        }));
                    });
                } else {
                    console.warn("No matching subscriptions found for this customer and scheme.");
                }
    
                // Execute all updates
                await Promise.all(updatePromises);
    
                // Update local state
                setPackedOrders(prevOrders =>
                    prevOrders.map(order =>
                        order.id === selectedOrder.id
                            ? { ...order, notes: orderNotes, trackingLink: trackingLink, slipURL: slipURL }
                            : order
                    )
                );
    
                fetchData();
                handleCloseNotesModal();
                setToastMessage('Order and subscription processed successfully');
                setToastVariant('success');
                setShowToast(true);
            }
        } catch (error) {
            console.error('Error updating order and subscription notes:', error);
            setToastMessage('Error updating order and subscription. Please try again.');
            setToastVariant('danger');
            setShowToast(true);
        }
    };
    
    

    const handleMovePackOrder = async (order) => {
        try {
            console.log(order);
            if (order) {
                const orderQuery = query(
                    collection(db, 'order-processing'),
                    where('customerId', '==', order.cusmid)
                );
    
                const subscriptionQuery = query(
                    collection(db, 'subscriptions'),
                    where('userId', '==', order.cusmid)
                );
    
                // Fetch order-processing document
                const orderSnapshot = await getDocs(orderQuery);
    
                const updatePromises = [];
    
                if (!orderSnapshot.empty) {
                    orderSnapshot.docs.forEach(docSnap => {
                        const orderRef = doc(db, 'order-processing', docSnap.id);
                        updatePromises.push(updateDoc(orderRef, {
                            PackingStatus: "Packed",
                            packedUser: currentUser ? currentUser.username : 'Unknown',
                        }));
                    });
                } else {
                    console.warn("No order found for this customer.");
                }
    
                // Fetch subscription document
                const subscriptionSnapshot = await getDocs(subscriptionQuery);
    
                // Update subscription document(s)
                if (!subscriptionSnapshot.empty) {
                    subscriptionSnapshot.docs.forEach(docSnap => {
                        const subscriptionRef = doc(db, 'subscriptions', docSnap.id);
                        updatePromises.push(updateDoc(subscriptionRef, {
                            PackingStatus: "Packed",
                            packedUser: currentUser ? currentUser.username : 'Unknown',
                        }));
                    });
                } else {
                    console.warn("No subscription found for this customer.");
                }
    
                // Execute all updates
                await Promise.all(updatePromises);
    
                // Update local state after Firestore update
                setBilledOrders(prevOrders =>
                    prevOrders.filter(o => o.id !== order.id)
                );
    
                setPackedOrders(prevOrders => [
                    ...prevOrders,
                    { ...order, PackingStatus: "Packed" }
                ]);
    
                // Show success toast
                setToastMessage('Order and subscription status updated to Packed successfully');
                setToastVariant('success');
                setShowToast(true);
                fetchData();
            }
        } catch (error) {
            console.error('Error updating order and subscription status:', error);
            setToastMessage('Error updating order and subscription status. Please try again.');
            setToastVariant('danger');
            setShowToast(true);
        }
    };
    
    

    const handlePrintSlip = async (order) => {
        try {
            console.log(order)
            const storageRef = ref(storage, `deliverySlips/${order.cusmid}_${order.schemeId}.pdf`);
            const deliverySlipURL = await getDownloadURL(storageRef);
            window.open(deliverySlipURL, '_blank');
        } catch (error) {
            console.error('Error fetching delivery slip:', error);
            setToastMessage('Error fetching delivery slip. Please try again.');
            setToastVariant('danger');
            setShowToast(true);
        }
    };


    if (!scheme) {
    
            // Render loading screen
            return (
              <div className="loading-screen">
              <Loading/>
              </div>
            );
          
    }



    const sendNotificationToServer = async (fcmToken, customerName) => {
        try {
            await fetch("http://192.168.1.55:5000/api/send-notification", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ fcmToken, customerName })
            });
          } catch (error) {
            console.error("Error sending request to backend:", error);
        }
    };
    

    return (
        <Container fluid className="mt-5">
            <ToastAlert
                show={showToast}
                setShow={setShowToast}
                message={toastMessage}
                variant={toastVariant}
            />
          
                <Row>
                    <Col>
                        <h1>Packing</h1>
                        <h3>Scheme : {scheme.name}</h3>
                       <Button variant='outline-success' className='btn' onClick={syncData}>Sync</Button>
                    </Col>
                   <Col className="text-end">
                   <Row>
                        <Col md={4} sm={4} className="mb-4">
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{packedCustomers.length + notPackedCustomers.length}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <center>
                                        <h5 className="cus-head">Total packages</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                       
                        <Col md={4} sm={4} className="mb-4">
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{packedCustomers.length}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <center>
                                            <h5 className="cus-head">Packed</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} sm={4} className="mb-4">
                        <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{notPackedCustomers.length}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                    <center>
                                        <h5 className="cus-head">Not packed</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                     
                    </Row>

                    </Col>
                </Row>
          
               
            <Tabs
                id="Process-order"
                activeKey={activeTab2}
                onSelect={(k) => setActiveTab2(k)}
                className="mb-3"
            >
                
                <Tab eventKey="notpacked" title="Not packed">
                    <Card className="mb-4" >
                        <Card.Body>
                                  <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                                <Table striped bordered hover responsive>
                                                                    <thead>
                                                                        <tr className='scheme-det-font-head'>
                                                                            <th>Id</th>
                                                                            <th>Name</th>
                                                                            <th>Phone</th>
                                                                            <th>Billing</th>
                                                                            <th>Packing</th>
                                                                            <th>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                      
                                                                    {notPackedCustomers.length > 0 ? (
                                                                    notPackedCustomers.map((order, index) => (
                                                                        <tr key={index} className='scheme-det-font'>
                                                                            <td>{order.cusmid}</td>
                                                                            <td>{order.name}</td>
                                                                            <td>{order.phone}</td>
                                                                            <td>{billingUsers.find(user => user.id === order.billingUserId)?.username || 'Not Assigned'}</td>
                                                                            <td>{logisticsUsers.find(user => user.id === order.logisticsUserId)?.username || 'Not Assigned'}</td>
                                                                            <td>
                                                                                <Button variant="outline-secondary"style={{marginLeft:'5px'}} className='btn btn' onClick={() => handlePrintSlip(order)}>
                                                                                    <FaPrint/> Print Slip
                                                                                </Button>
                                                                                <Button variant="outline-primary" style={{marginLeft:'5px'}} className='btn btn' onClick={() => handleMovePackOrder(order)}>
                                                                                    <FaBoxesPacking/> Mark as packed
                                                                                </Button>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="5">No customers found.</td>
                                                                    </tr>
                                                                )}
                                                                        {/* Add customer data here */}
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                            </Card.Body>
                        </Card>
                    </Tab>
                <Tab eventKey="packed" title="Packed">
                    <Card className="mb-4" >
                        <Card.Body>
                            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                <Table striped bordered hover responsive >
                                    <thead>
                                        <tr className='scheme-det-font-head'>
                                          
                                            <th>Customer ID</th>
                                            <th>Name</th>
                                            <th>Billing</th>
                                            <th>Packing</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {packedCustomers.length > 0 ? (
                                    packedCustomers.map((order, index) => (
                                        <tr key={index} className='scheme-det-font'>
                                            <td>{order.cusmid}</td>
                                            <td>{order.name}</td>
                                            <td>{billingUsers.find(user => user.id === order.billingUserId)?.username || 'Not Assigned'}</td>
                                            <td>{logisticsUsers.find(user => user.id === order.logisticsUserId)?.username || 'Not Assigned'}</td>                             
                                            <td>
                                                <Button variant="outline-primary" style={{marginLeft:'5px'}} className='btn btn' onClick={() => handleShowNotesModal(order)}>
                                                    <FaNoteSticky/> Order Notes
                                                </Button>
                                                <Button variant="outline-secondary"style={{marginLeft:'5px'}} className='btn btn' onClick={() => handlePrintSlip(order)}>
                                                    <FaPrint/> Print Slip
                                                </Button>
                                                {/* <Button variant="outline-primary" style={{marginLeft:'5px'}} className='btn btn' onClick={() => handleMovePackOrder(order)}>
                                                    <FaBoxesPacking/> Mark as packed
                                                </Button> */}
                                            </td>
                                        
                                        </tr>
                                    ))
                                    
                                ) : (
                                    <tr>
                                        <td colSpan="5">No packed orders found.</td>
                                    </tr>
                                )}
                                        {/* Add customer data here */}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>
                </Tab>
            
            </Tabs>
          
        

            <Modal show={showNotesModal}  onHide={handleCloseNotesModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Order Notes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Notes</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={orderNotes}
                            onChange={(e) => setOrderNotes(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Tracking Link</Form.Label>
                        <Form.Control
                            type="text"
                            value={trackingLink}
                            onChange={(e) => setTrackingLink(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Upload Slip</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={(e) => {
                                setUploadedSlip(e.target.files[0]);
                                setUploadedSlipURL(URL.createObjectURL(e.target.files[0]));
                            }}
                        />
                    </Form.Group>
                    {uploadedSlipURL && (
                        <div className="mb-3">
                            <Form.Label>Uploaded Slip Preview</Form.Label>
                            <img src={uploadedSlipURL} alt="Uploaded Slip" style={{ width: '100%', height: 'auto' }} />
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" className='btn btn' onClick={handleCloseNotesModal}>
                        Close
                    </Button>
                    <Button variant="outline-success" className='btn btn' onClick={handleNotesSubmit}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
          
          
        </Container>
    );
};

export default ProcessScheme;